module.exports = __webpack_public_path__ + "static/img/48-6.e76acc1.png";